<template>
<form novalidate @keyup.enter="login">
    <md-input-container :class="{'md-input-invalid': emailError()}">
        <label>Email</label>
        <md-input v-model="email" type="email" required></md-input>
        <span class="md-error" v-if="emailError">{{errorMessage}} <a v-if="verifyError && !sent" class="send-verification-email" @click="sendVerficationEmail">Send Verification Email</a></span>
    </md-input-container>
    <md-input-container :class="{'md-input-invalid': passwordError()}">
        <label>Password</label>
        <md-input v-model="password" type="password" required ></md-input>
        <span class="md-error" v-if="passwordError">{{errorMessage}}</span>
    </md-input-container>
    <div class="login-wrapper">
        <md-button class="md-raised md-primary" @click="login"><md-icon>mail</md-icon>&nbsp;Sign In</md-button>
        <md-button class="btn-troubleshoot" @click="forgot">Forgot Password</md-button>
    </div>
</form>
</template>

<script>
import firebase from 'firebase';

function UnverifiedException() {
    this.code = 'auth/unverified-email';
    this.message = 'This email is not confirmed yet.';
}

const LoginForm = {
    name: 'LoginForm',
    data: function() {
        return {
            email: '',
            password: '',
            errorCode: '',
            errorMessage: '',
            sent: false
        };
    },
    methods: {
        forgot() {
            this.$router.replace('/forgot');
        },
        login() {
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then((user) => {
                if (!user.emailVerified) {
                    this.sent = false;
                    throw new UnverifiedException();
                }
                this.$router.replace('/dashboard');
            }).catch((error) => {
                this.errorCode = error.code;
                this.errorMessage = error.message;
            });
        },
        verifyError() {
            return this.errorCode === 'auth/unverified-email';
        },
        emailError() {
            return this.errorCode === 'auth/invalid-email' || this.errorCode === 'auth/unverified-email';
        },
        passwordError() {
            return this.errorCode === 'auth/wrong-password';
        },
        sendVerficationEmail() {
            firebase.auth().currentUser.sendEmailVerification().then(() => {
                this.sent = true;
            });
        }
    }
};
export default LoginForm;
</script>

<style lang="scss">
.login-wrapper {
    position: relative;
    .btn-troubleshoot {
        // font-size: 12px;
        position: absolute;
        float: right;
        text-transform: none;
        font-weight: 600;
        letter-spacing: 0.5px;
    }
}
.send-verification-email {
    text-decoration: underline !important;
    cursor: pointer;
    color: #000 !important;
    transition: color 0.15s ease;
    font-size: 1.3em;
    &:hover {
        color: #5ecfdf !important;
    }
}
</style>


// WEBPACK FOOTER //
// login-form.vue?6b3a3408